export class LAmeta {
    defaultColors: string[] = ["#5A8770", "#B2B7BB", "#6FA9AB", "#F5AF29", "#0088B9", "#F18636", "#D93A37", "#A6B12E", "#5C9BBC", "#F5888D", "#9A89B5", "#407887", "#9A89B5", "#5A8770", "#D33F33", "#A2B01F", "#F0B126", "#0087BF", "#F18636", "#0087BF", "#B2B7BB", "#72ACAE", "#9C8AB4", "#5A8770", "#EEB424", "#407887"];
    defaultTextColor: string = '#ffffff';
    defaultBorder: string = 'border:5px solid white';
    defaultTriangleup: string = 'width: 0;height: 0;border-left: 50px solid transparent;border-right: 50px solid transparent;border-bottom: 100px solid;';
    deafultFontsize: string = '30';
    defaultHeight: string = '50';
    deafultWidth: string = '50';
    defaultRadius: string = 'border-radius:50%;';
    deafultDynamic: string = 'false';
    defaultRotatedeg: string = '0';
    defaultAvatarborder:string = 'false';
    defaultFontWeight: string = '400';
    defaultFontFamily: string = 'HelveticaNeue-Light,Helvetica Neue Light,Helvetica Neue,Helvetica, Arial,Lucida Grande, sans-serif';
}

export class Attributes {
    alphabetcolors: string = 'avatar-alphabet-colors';
    textColor: string = 'avatar-text-color';
    defaultBorder: string = 'avatar-default-border';
    triangleup: string = 'avatar-triangle-up';
    fontsize: string = 'avatar-font-size';
    height: string = 'avatar-height';
    width: string = 'avatar-width';
    radius: string = 'avatar-radius';
    avatarcustombgcolor: string = 'avatar-custom-bg-color';
    dynamic: string = 'avatar-dynamic';
    fontWeight: string = 'avatar-font-weight';
    fontFamily: string = 'avatar-font-family';
    shape: string = 'avatar-shape';
    data: string = 'avatar-data';
    rotatedeg: string = 'avatar-rotate-degree';
    avatarborder:string = 'avatar-border';

}




// WEBPACK FOOTER //
// ./src/app/library/ngu-utility/letter-avatar/lameta.ts